import React, { useState, useEffect } from "react";
import { VendorInstructions, VendorListHolder } from "./vendorReg";
import info from "../../../../assets/icon.png";
import styled from "styled-components";
import { Button, Card, CardContent, Grid, TextField } from "@mui/material";
import { styled as styled1 } from "@mui/material/styles";
import { StyledCard } from "../StepMainEdit";
import LoadingButton from "@mui/lab/LoadingButton";
import RecipeReviewCard from "./cardTrialEdit";
import Box from "@mui/material/Box";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  bussinesslocationsupdate,
  GSTdocument,
} from "../../redux/vendorRegistrationSlice";
import { history } from "../../../../app/history";
import { message } from "antd";
// import { hasDuplicates } from "../../../../utilities/helper";
import { getNotification } from "../../../notification/redux/notificationSlice";
import { useFeature } from "../../../../common/featureFlags/FeatureProvider";
// import LocalStorage from "../../../../utilities/localStorage";

function BankRegEdit({
  activeStep,
  handleBack,
  vendor_details,
  clientId,
  is_domestic,
  setActiveStep,
  setSkipped,
  isStepSkipped,
  skipped,
  isApproved,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    unregister,
  } = useForm({ shouldUnregister: true });

  const [expanded, setExpanded] = useState({});
  const [locations, setLocations] = useState([]);
  const [contacts, setContacts] = useState({});
  const [loading, setLoading] = useState(false);
  const [registerType, setRegisterType] = useState("");
  const isVendorApproval = useFeature("vendor_approval_workflow");
  const bankDocMandatory = useFeature("bank_doc_mandatory");
  const skipLocationUpdate = useFeature("skip_location_update");
  const disableMultipleLocations = useFeature("disable_multiple_locations");

  const handleExpandClick = (ind) => {
    setExpanded({
      ...expanded,
      [ind]: !expanded[ind],
    });
  };

  const handleSetContacts = (ind, val) => {
    setContacts({
      ...contacts,
      [ind]: val,
    });
  };

  useEffect(() => {
    if (vendor_details?.Locations) {
      setLocations(vendor_details?.Locations);
      setRegisterType(vendor_details?.gst_registration_type);
      let selectedContacts = {};
      vendor_details.Locations.forEach((item, index) => {
        selectedContacts[index] = item.Contacts || [];
      });
      setContacts(selectedContacts);
    }
    // eslint-disable-next-line
  }, [vendor_details?.gst_registration_type]);

  const dispatch = useDispatch();

  const handleSave = () => {
    const uniqueData = locations.filter(
      (obj, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            t.address_line_one === obj.address_line_one &&
            t.address_line_two === obj.address_line_two &&
            t.location === obj.location &&
            t.city === obj.city &&
            t.state === obj.state
        )
    );
    if (uniqueData.length !== locations.length) {
      return message.error("Duplicate location");
    }
    // const isDuplicate = hasDuplicates(
    //   locations,
    //   [],
    //   ["contacts", "phone", "branch_email"]
    // );
    // if (isDuplicate) {
    //   return message.error("Duplicate location");
    // }

    const isGstRequired = is_domestic === true && registerType !== "unregistered";
    let hasValidationError = false;
    let firstErrorIndex = -1;
    clearErrors();

    for (let i = 0; i < locations.length; i++) {
      const loc = locations[i] || {};
      const isDocEmpty =
        !loc.gst_document_image_name ||
        loc.gst_document_image_name === "" ||
        loc.gst_document_image_name === "null" ||
        loc.gst_document_image_name === "undefined";
      const isGstEmpty =
        !loc.gst_id ||
        loc.gst_id === "null" ||
        loc.gst_id === "undefined" ||
        (typeof loc.gst_id === "string" && loc.gst_id.trim() === "");
      const isLocEmpty = !loc.location || String(loc.location).trim() === "";
      const isPhoneEmpty = !loc.phone || String(loc.phone).trim() === "";
      const isEmailEmpty = !loc.branch_email || String(loc.branch_email).trim() === "";

      if (isGstRequired) {
        if (isGstEmpty) {
          setError(`gst_id_${i}`, { type: "manual", message: "Please enter GST number" });
          hasValidationError = true;
          if (firstErrorIndex === -1) firstErrorIndex = i;
        }
        if (isDocEmpty) {
          setError(`gst_document_image_name_${i}`, { type: "manual", message: "Please upload GST copy" });
          hasValidationError = true;
          if (firstErrorIndex === -1) firstErrorIndex = i;
        }
      }

      if (isLocEmpty) {
        setError(`location_${i}`, { type: "manual", message: "Please enter/select location" });
        hasValidationError = true;
        if (firstErrorIndex === -1) firstErrorIndex = i;
      }
      if (isPhoneEmpty) {
        setError(`phone_${i}`, { type: "manual", message: "Please enter phone number" });
        hasValidationError = true;
        if (firstErrorIndex === -1) firstErrorIndex = i;
      }
      if (isEmailEmpty) {
        setError(`branch_email_${i}`, { type: "manual", message: "Please enter email" });
        hasValidationError = true;
        if (firstErrorIndex === -1) firstErrorIndex = i;
      }
    }

    if (hasValidationError) {
      if (firstErrorIndex !== -1 && !expanded[firstErrorIndex]) {
        handleExpandClick(firstErrorIndex);
      }
      setLoading(false);
      return;
    }

    // For non-unregistered GST types, ensure every location has been validated
    if (registerType && registerType !== "unregistered") {
      const unvalidatedIndex = locations.findIndex(
        (loc) => loc.gst_id && !loc.is_gst_valid
      );
      if (unvalidatedIndex !== -1) {
        return message.error(
          `Please validate the GST number for Business Location ${unvalidatedIndex + 1} before saving.`
        );
      }
    }

    setLoading(true);
    let data = locations.map((item, index) => {
      let modifiedContacts = (contacts[index] || []).map((con) => {
        delete con.edit;
        return con;
      });

      return {
        ...item,
        contacts: modifiedContacts,
      };
    });

    let promises = [];
    data.forEach((item) => {
      const { gst_document_image_name } = item;

      if (
        typeof gst_document_image_name === "object" &&
        gst_document_image_name !== null
      ) {
        let formData = new FormData();
        formData.append("file", gst_document_image_name);

        promises.push(dispatch(GSTdocument(formData)));
      } else {
        promises.push(
          Promise.resolve({ payload: { data: "nochange", success: true } })
        );
      }
    });

    Promise.all(promises).then((responses) => {
      if (responses.every((o) => o?.payload?.success)) {
        responses.forEach((res, ind) => {
          if (res?.payload?.data !== "nochange") {
            data[ind] = {
              ...data[ind],
              gst_document_image: res?.payload?.data?.Location || null,
              gst_document_image_name: res?.payload?.data?.file_name || null,
            };
          }
        });
        if (registerType === "unregistered" || !registerType) {

          data = data.filter(
            (obj) =>
              obj.branch_email.trim() !== "" &&
              obj.phone.trim() !== "" &&
              obj.location !== ""
          );
          // data = data.filter(
          //   (obj) =>
          //     obj.branch_email.trim() !== "" &&
          //     obj.phone.trim() !== "" &&
          //     obj.location !== "" &&
          //     obj.gst_document_image_name !== ""
          // );
        } else {
          // data = data.filter(
          //   (obj) =>
          //     obj.branch_email.trim() !== "" &&
          //     obj.phone.trim() !== "" &&
          //     obj.location !== ""
          // );
          data = data.filter(
            (obj) =>
              obj.branch_email.trim() !== "" &&
              obj.phone.trim() !== "" &&
              obj.location !== "" &&
              obj.gst_document_image_name !== ""
          );
        }
        if (!data.length) {
          message.info("Add at least one business location");
          setLoading(false);
          return;
        }
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }

        if (vendor_details?.Locations && !skipLocationUpdate) {
          dispatch(bussinesslocationsupdate({ data })).then((response) => {
            if (response?.payload?.success) {
              dispatch(getNotification());
              setLoading(false);
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              setSkipped(newSkipped);
            } else {
              setLoading(false);
              message.error(
                response?.payload?.message ||
                  response?.payload?.errorMessage ||
                  "Something went wrong"
              );
            }
          });
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setSkipped(newSkipped);
        }
      } else {
        setLoading(false);
        const failedObj = responses.find((o) => !o?.payload?.success);
        const errorDetail =
          failedObj?.payload?.message ||
          failedObj?.payload?.error ||
          failedObj?.error?.message;

        message.error(
          errorDetail ||
            `Error uploading Business location ${
              responses.findIndex((o) => !o?.payload?.success) + 1
            } GST document. Submission failed`
        );
      }
    });
  };

  const handleAddLocation = () => {
    let locationsCopy = [...locations];

    locationsCopy.push({
      location_gst_id: "",
      location: "",
      phone: "",
      branch_email: "",
      fax_number: "",
      state: "",
      gst_document_image_name: "",
    });

    handleExpandClick(locationsCopy.length - 1);
    setLocations(locationsCopy);
  };

  const handleLocationDelete = (index) => {
    for (let i = 0; i <= locations.length; i++) {
      unregister(`gst_id_${i}`);
      unregister(`location_${i}`);
      unregister(`phone_${i}`);
      unregister(`branch_email_${i}`);
      unregister(`fax_number_${i}`);
      unregister(`gst_document_image_name_${i}`);
    }
    clearErrors();

    let locationsCopy = [...locations];
    // eslint-disable-next-line
    locationsCopy = locationsCopy.filter((_, i) => i != index);

    setLocations(locationsCopy);

    // Shift contacts state keys
    const newContacts = {};
    Object.keys(contacts || {}).forEach((key) => {
      const k = parseInt(key);
      if (k < index) {
        newContacts[k] = contacts[k];
      } else if (k > index) {
        newContacts[k - 1] = contacts[k];
      }
    });
    setContacts(newContacts);

    // Shift expanded state keys
    const newExpanded = {};
    Object.keys(expanded || {}).forEach((key) => {
      const k = parseInt(key);
      if (k < index) {
        newExpanded[k] = expanded[k];
      } else if (k > index) {
        newExpanded[k - 1] = expanded[k];
      }
    });
    setExpanded(newExpanded);
  };

  const handleLocationOnchange = (e, index) => {
    let { name, value } = e.target;

    if (name && name.includes(`_${index}`)) {
      name = name.replace(`_${index}`, "");
    }

    let locationsCopy = [...locations];

    let extra = {};
    if (name === "gst_document_image_name") {
      extra = {
        ...extra,
        gst_document_image: null,
      };
    }

    locationsCopy[index] = {
      ...(locationsCopy[index] || {}),
      [name]: value,
      ...extra,
    };

    setLocations(locationsCopy);
  };
  return (
    <div>
      <StyledCard>
        <CardContent>
          <VendorInstructions>
            <img src={info} alt="info" /> Instructions
          </VendorInstructions>
          <br />
          <VendorListHolder>
            <li>
              This is a API enabled form. E-mail and GSTIN data will need to be
              validated automatically before you can submit it.
            </li>
            <li>
              Click on Validate below the GSTIN field and select the location
              from the drop down list in the location field.
            </li>
            <li style={{ paddingBottom: "5px" }}>
              Address details will be autopopulated and are not editable.
            </li>
            {isVendorApproval && (
              <li style={{ paddingBottom: "5px", color: "#FF5733" }}>
                Business Location cannot be edited.
              </li>
            )}
          </VendorListHolder>
        </CardContent>
      </StyledCard>

      <form onSubmit={handleSubmit(handleSave)}>
        {locations.map((location_item, index) => (
          <RecipeReviewCard
            key={index}
            l_index={index}
            location_item={location_item}
            register={register}
            errors={errors}
            clearErrors={clearErrors}
            expanded={expanded[index] || false}
            handleExpandClick={handleExpandClick}
            contacts={contacts[index] || []}
            setContacts={(value) => handleSetContacts(index, value)}
            onChange={handleLocationOnchange}
            onDelete={handleLocationDelete}
            registerType={registerType}
            clientId={clientId}
            is_domestic={is_domestic}
          />
        ))}

        {isVendorApproval || (bankDocMandatory && locations.length === 1) || (disableMultipleLocations && locations.length >= 1) ? (
          ""
        ) : (
          <AddBusinessCard>
            <CardContent>
              <Grid onClick={handleAddLocation}>
                <LocationDiv>+ Add business location</LocationDiv>
              </Grid>
            </CardContent>
          </AddBusinessCard>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            pt: 2,
            justifyContent: "space-between",
          }}
        >
          <Button
            color="inherit"
            disabled={!activeStep}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Back
          </Button>
          {/* <Box sx={{ flex: "1 1 auto" }} /> */}
          <LoadingButton
            sx={{
              textTransform: "none",
              background: "var(--button-color)",
              width: "200px",
              height: "40px",
            }}
            color="success"
            variant="contained"
            type="submit"
            loading={loading}
            loadingPosition="start"
          >
            Save & Next
          </LoadingButton>
        </Box>
      </form>
    </div>
  );
}

export default BankRegEdit;

export const LocationDiv = styled.div`
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  top: 50%;
  left: 50%;
  text-align: center;
  color: #271fe0;
  :hover {
    cursor: pointer;
  }
`;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorLabelHolder = styled.div`
  text-align: left;
  padding: 0 20px 20px 20px;
`;

export const StyledContainedButton = styled(Button)`
  text-transform: none;
  background-color: #dcdce4;
  margin-left: 15px;
  color: white;
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  border-radius: 4px;
  padding: 5px 30px 5px 30px;

  :active {
    color: grey;
  }
  :hover {
    border: 1px solid var(--button-color);
    background-color: white;
    color: black;
  }
`;

export const StyledTextField = styled(TextField)`
  font-family: var(--font-family-med);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  width: 320px;
  outline: none;
  /* Neutral/200 */
  ::placeholder {
    font-family: var(--font-family-med);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }

  ::after {
    border-bottom: 1px solid #dcdce4;
  }

  :active {
    border-bottom: 1px solid #dcdce4;
  }
  border-bottom: 1px solid #dcdce4;
`;

export const AddBusinessCard = styled1(Card)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;

border: 1px dashed #C0c0cf;
height: 70px;
`;
